// src/pages/Profile/components/VideosTab.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
 
/* ── Small inline logo loader ── */
const MiniLogoLoader = ({ label }) => (
  <div className="mini-loader-wrap">
    <div className="mini-logo">
      <div className="mini-bar-wrap mini-bar-left">
        <div className="mini-bar-fill mini-fill-left" />
      </div>
      <div className="mini-bar-wrap mini-bar-center">
        <div className="mini-bar-fill mini-fill-center" />
      </div>
      <div className="mini-bar-wrap mini-bar-right">
        <div className="mini-bar-fill mini-fill-right" />
      </div>
    </div>
    {label && <p className="mini-loader-label">{label}</p>}
  </div>
);
 
const VideosTab = ({ videos, loading, error }) => {
  const [selectedVideo, setSelectedVideo] = useState(null);
  const navigate = useNavigate();
 
  const formatDuration = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };
 
  const handleVideoClick = (video) => {
    // Navigate to the video detail page instead of opening modal
    navigate(`/video/${video.id}`);
  };
 
  const closeVideoPlayer = () => {
    setSelectedVideo(null);
  };
 
  return (
    <div className="profile-tab-content">
      <div className="tab-header">
        <span className="tab-icon">🎥</span>
        <h2>Content</h2>
      </div>
 
      {loading ? (
        <div className="loading-state">
          <MiniLogoLoader label="Loading videos..." />
        </div>
      ) : error ? (
        <div className="error-state">{error}</div>
      ) : videos.length === 0 ? (
        <div className="empty-state">
          <p>No videos available</p>
        </div>
      ) : (
        <>
          <div className="videos-list">
            {videos.map((video) => (
              <div 
                key={video.id} 
                className="video-card"
                onClick={() => handleVideoClick(video)}
              >
                <div className="video-left">
                  <div className="video-avatar">
                    {video.thumbnail_url ? (
                      <img src={video.thumbnail_url} alt={video.title} />
                    ) : (
                      <div className="avatar-placeholder">
                        {video.channel_name ? video.channel_name.substring(0, 2).toUpperCase() : 'FH'}
                      </div>
                    )}
                  </div>
                  <div className="video-info">
                    <h3 className="video-item-name">{video.channel_name || video.title}</h3>
                    <p className="video-item-subtitle">{video.description || video.title}</p>
                  </div>
                </div>
                <div className="video-right">
                  <span className="video-duration">
                    🕐 {video.duration_formatted || formatDuration(video.duration)}
                  </span>
                  <span className="video-views">👁 {video.views.toLocaleString()} views</span>
                </div>
              </div>
            ))}
          </div>
 
          {/* Video Player Modal - Still kept for any other usage if needed */}
          {selectedVideo && (
            <div className="video-modal-overlay" onClick={closeVideoPlayer}>
              <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="close-modal-btn" onClick={closeVideoPlayer}>
                  ✕
                </button>
                <h3 className="modal-video-title">{selectedVideo.title}</h3>
                {selectedVideo.video_url ? (
                  <video 
                    controls 
                    autoPlay
                    className="video-player"
                    src={selectedVideo.video_url}
                  >
                    Your browser does not support the video tag.
                  </video>
                ) : (
                  <div className="video-error">Video file not available</div>
                )}
                {selectedVideo.description && (
                  <p className="modal-video-description">{selectedVideo.description}</p>
                )}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};
 
export default VideosTab;